import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import tools from '../../../tools';

class ToolDeleteRowsOrColumns extends Tool {
  static toolName = 'Delete rows or columns';
  static iconClass = 'fa-regular fa-minus';
  static submenuTools = () => [[tools.ToolDeleteRow, tools.ToolDeleteColumn]];

  static isEnabled({ editor, controller }: ToolArgsWithController) {
    return (
      tools.ToolDeleteRow.isEnabled({ editor, controller }) ||
      tools.ToolDeleteColumn.isEnabled({ editor, controller })
    );
  }
}

export default ToolDeleteRowsOrColumns;
